import React, { useContext } from "react";

import "../sass/styles.sass";
import Navbar from "../components/element/navbar/Navbar";
import Footer from "../components/element/footer/PublicFooter";
import { AppContext } from "../data/ContextProvider";

function EmptyLayout(props) {
  const context = useContext(AppContext);

  return (
    <React.Fragment>
      <Navbar bgColor={"black"} isScrolling={true} />
      <div className={`container ${props.fullHeight ? "container--full-height" : ""} ${context.getProjectData().global_jackpot_active ? "container--jackpot-counter" : ""}`}>
        {props.children}
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default EmptyLayout;
